<template>
  <div class="reportTable">
    <div class="item" @click="handleClick" >
      <div class="item-left">
        <div>
          <a-icon type="caret-right" style="font-size: 26px; opacity: 0" />
        </div>
        <div>
          <img v-if="icon" class="avatar" :src="data.avatar ? data.avatar : imgUrl" />
          <div v-else class="avatar">
            <a-icon style="font-size: 20px; color: #fff" type="fund" />
          </div>
        </div>
        <div class="name">
          <span v-if="icon">{{ store ? data.store : team ? data.team : person ? data.name : '' }} </span>
          <span v-else>总计</span>
        </div>
      </div>

      <div class="num" style="margin-left:20px">
        <span v-if="data">{{ data.cnewHouse }} </span>
        <span v-if="data">{{ data.ceffective }}</span>
        <span v-if="data">{{ data.cfollowHouse }} </span>
        <span v-if="data">{{ data.lookByHouse }} </span>
        <span v-if="data">{{ data.cnewCustomer }} </span>
        <span v-if="data">{{ data.lookByCustomer }} </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    data: {
      type: Object,
    },
    store: {
      type: String,
    },
    team: {
      type: String,
    },
    person: {
      type: String,
    },
  },
  data() {
    return {
      imgUrl: require('@/assets/home-imgs/头像.svg'),
    }
  },
  methods: {
    handleClick() {
      this.$emit('isOpen', this.data.storeId)
    },
  },
}
</script>

<style lang="less" scoped>
.reportTable {
  .item {
    display: flex;
    align-items: center;
    .item-left {
      width: 240px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .avatar {
        margin-left: 10px;
        margin-right: 20px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: var(--ThemeColor);
        text-align: center;
        line-height: 60px;
        & > span {
          color: #fff;
          font-weight: 700;
          font-size: 16px;
        }
      }
      .name {
        width: 130px;
      }
    }
    .num {
      flex: 1;
      color: #222;
      font-size: 16px;
      display: flex;
      justify-content: space-around;
    }
  }
  /deep/.ant-divider {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>